import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'publisher/reducers/webinarReducer'

export { selectors }

export default function useWebinar(selector) {
  return useSelector(state => selector(state.webinar), shallowEqual)
}
